import { render, staticRenderFns } from "./FacebookCofig.vue?vue&type=template&id=aa719bc0&"
import script from "./FacebookCofig.vue?vue&type=script&lang=js&"
export * from "./FacebookCofig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports